import { Loader } from '@shared/designSystem/Loader';

interface LoadingProps {
    height?: string;
    width?: string;
    loaderHeight?: string;
    loaderWidth?: string;
    className?: string;
}

const Loading: React.FC<LoadingProps> = ({
    height = '100%',
    width = '100%',
    loaderHeight = '60px',
    loaderWidth = '60px',
    className,
}) => {
    return (
        <div className={className} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height, width }}>
            <Loader height={loaderHeight} width={loaderWidth} />
        </div>
    )
}


export default Loading;
